const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');

class MadBotAIStory {
    constructor (runtime) {
        this.runtime = runtime;
        this.serverUrl = 'https://madbot.in/ai-story.php';
        this.language = 'English';
        this.style = 'Adventure';
        this.story = '';
        this.error = '';
        this.ready = false;
    }

    getInfo () {
        return {
            id: 'madbotAIStory',
            name: 'MadBot AI Story',
            color1: '#F88A17',
            color2: '#D96F00',
            color3: '#9C4F00',
            blocks: [
                {
                    blockType: BlockType.LABEL,
                    text: 'Settings'
                },
                {
                    opcode: 'setServerUrl',
                    blockType: BlockType.COMMAND,
                    text: 'set AI server URL [URL]',
                    arguments: {
                        URL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'https://yourdomain.com/ai-story.php'
                        }
                    }
                },
                {
                    opcode: 'setLanguage',
                    blockType: BlockType.COMMAND,
                    text: 'set story language [LANG]',
                    arguments: {
                        LANG: {
                            type: ArgumentType.STRING,
                            menu: 'languageMenu',
                            defaultValue: 'English'
                        }
                    }
                },
                {
                    opcode: 'setStyle',
                    blockType: BlockType.COMMAND,
                    text: 'set story style [STYLE]',
                    arguments: {
                        STYLE: {
                            type: ArgumentType.STRING,
                            menu: 'styleMenu',
                            defaultValue: 'Adventure'
                        }
                    }
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Generate Story'
                },
                {
                    opcode: 'generateStory',
                    blockType: BlockType.COMMAND,
                    text: 'generate story about [TOPIC]',
                    arguments: {
                        TOPIC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'a robot helping students'
                        }
                    }
                },
                {
                    opcode: 'getStory',
                    blockType: BlockType.REPORTER,
                    text: 'AI story'
                },
                {
                    opcode: 'isReady',
                    blockType: BlockType.BOOLEAN,
                    text: 'AI story ready?'
                },
                {
                    opcode: 'getError',
                    blockType: BlockType.REPORTER,
                    text: 'AI error'
                }
            ],
            menus: {
                languageMenu: {
                    acceptReporters: true,
                    items: ['English', 'Hindi', 'Gujarati']
                },
                styleMenu: {
                    acceptReporters: true,
                    items: ['Adventure', 'Funny', 'Moral', 'Sci-Fi', 'Mystery', 'Educational']
                }
            }
        };
    }

    setServerUrl (args) {
        this.serverUrl = String(args.URL).trim();
    }

    setLanguage (args) {
        this.language = String(args.LANG);
    }

    setStyle (args) {
        this.style = String(args.STYLE);
    }

    async generateStory (args) {
        const topic = String(args.TOPIC).trim();

        this.ready = false;
        this.story = '';
        this.error = '';

        if (!topic) {
            this.error = 'Please enter a story topic.';
            return;
        }

        try {
            const response = await fetch(this.serverUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    topic: topic,
                    language: this.language,
                    style: this.style
                })
            });

            const data = await response.json();

            if (!response.ok || data.error) {
                this.error = data.error || 'AI server error.';
                return;
            }

            this.story = data.story || '';
            this.ready = true;
        } catch (e) {
            this.error = 'Cannot connect to AI server.';
        }
    }

    getStory () {
        return this.story;
    }

    isReady () {
        return this.ready;
    }

    getError () {
        return this.error;
    }
}

module.exports = MadBotAIStory;